module.exports = __webpack_public_path__ + "static/img/guidcollection.7238ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guidcollection.png
// module id = la5p
// module chunks = 1